var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[(!_vm.chart_ready || _vm.loading_dash)?_c('card-loading-transparent'):_vm._e(),(_vm.chart_ready && !_vm.loading_dash)?_c('bar-chart',{staticStyle:{"height":"100%","width":"100%"},attrs:{"chart-data":_vm.chart_data,"options":_vm.chart_options}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }